import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import * as paths from 'app-router/paths';
import { useAuth } from 'services/auth';
import { useStore } from 'stores';

const DashboardLink: React.FC = () => <Link to={paths.buildDashboardPath()} className="rbmediarpmslogo" />;

export const MenuBar: React.FC = () =>
{
  const authOptions = useAuth();
  const { uiStore } = useStore();

  const isUserLoggedIn = authOptions.authStore.currentUser !== undefined;

  return (
    <nav className="menu-bar">
      <div className="menu-start">
        <DashboardLink />
      </div>
      <div className="menu-center">
        {
          isUserLoggedIn
          ? <ul>
              <li><NavLink to={paths.buildFeatureListPath()} activeClassName="active">{uiStore.labels.pages.header.menu.features}</NavLink></li>
              <li><NavLink to={paths.buildToggleListPath()} activeClassName="active">{uiStore.labels.pages.header.menu.toggles}</NavLink></li>
              <li><NavLink to={paths.buildAudiencePath()} activeClassName="active">{uiStore.labels.pages.header.menu.audience}</NavLink></li>
            </ul>
          : null
        }
      </div>
      <div className="menu-end">
      </div>
    </nav>
  );
}